import { gql, useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { useSessionContext } from 'src/contexts';
import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';

export const SUPPORT_TOKENS_VALIDATION = gql`
  query supportTokensValidation(
    $memberToken: String!
    $supporterToken: String!
    $supportRequestId: ObjectId!
  ) {
    supportTokensValidation(
      memberToken: $memberToken
      supporterToken: $supporterToken
      supportRequestId: $supportRequestId
    )
  }
`;

export const useSupportAuth = () => {
  const query = useRouteQuery();
  const navigate = useNavigate();
  const memberToken = query.get('memberToken');
  const supporterToken = query.get('supporterToken');
  const supportRequestId = query.get('supportRequestId');
  const [session, updateSessionContext] = useSessionContext();

  const client = useApolloClient();

  if (memberToken && supporterToken && supportRequestId) {
    client
      .query({
        query: SUPPORT_TOKENS_VALIDATION,
        variables: { memberToken, supporterToken, supportRequestId },
      })
      .then(({ data }) => {
        const tokensValid = !!data?.supportTokensValidation;

        if (tokensValid) {
          updateSessionContext({
            ...session,
            accessToken: memberToken as string,
            isAuthenticated: true,
            redirectPath: ROUTES.dashboard,
          });

          navigate(ROUTES.dashboard);
        }
      });
  }
};
